export default __webpack_public_path__ + "static/media/list.5b962c7f.svg";